module.exports = __webpack_public_path__ + "static/productive-3cb440efefb2f449ed1aacd767d8f34d.png";